/**
 * Asynchronously loads the component for HomePage
 */

import { lazyLoad } from 'utils/loadable';

export const BuyingOrderPage = lazyLoad(
  () => import('./index'),
  module => module.BuyingOrderPage
);
